import React from 'react';

import * as S from './style';
import {EMPTY_OPTIONS, OPTION_HEIGHT, TIME_OPTIONS, TTime, TTimePickerType} from './types';
import {isAvailableTime} from './utils';

type TProps = {
  period: keyof TTime;
  onMouseEnter: (time: TTime) => void;
  onMouseLeave: TEmptyFunction;
  onSelect: (time: TTime) => void;
  selectedTime: TTime;
  minTime: Date;
  maxTime: Date;
  scrollToSelected?: TTime | null;
  type: TTimePickerType;
};

export const TimeColumn = React.memo<TProps>(
  ({
    scrollToSelected,
    minTime,
    maxTime,
    onMouseLeave,
    period,
    onMouseEnter,
    onSelect,
    selectedTime,
    type,
  }) => {
    const ref = React.useRef<HTMLDivElement>(null);

    React.useLayoutEffect(() => {
      if (selectedTime) {
        const value = selectedTime[period];

        if (typeof value === 'number' && ref.current) {
          ref.current.scrollTop = OPTION_HEIGHT * value;
        }
      }
    }, []);

    React.useLayoutEffect(() => {
      if (scrollToSelected) {
        const value = scrollToSelected[period];

        if (typeof value === 'number' && ref.current) {
          ref.current.scrollTo({top: OPTION_HEIGHT * value, behavior: 'smooth'});
        }
      }
    }, [scrollToSelected]);

    return (
      <S.TimeColumn ref={ref}>
        {TIME_OPTIONS[period].map((time) => {
          const isDisabled = !isAvailableTime(
            {...selectedTime, [period]: time},
            {
              minDate: minTime,
              maxDate: maxTime,
              period,
              type,
            },
          );

          return (
            <S.TimeSlot
              key={time}
              onMouseEnter={() => onMouseEnter({[period]: time})}
              onMouseLeave={onMouseLeave}
              onClick={() => onSelect({[period]: time})}
              disabled={isDisabled}
            >
              <S.TimeSlotStatus isSelected={!isDisabled && time === selectedTime[period]}>
                {String(time).padStart(2, '0')}
              </S.TimeSlotStatus>
            </S.TimeSlot>
          );
        })}
        {EMPTY_OPTIONS.map((_, index) => (
          <S.TimeSlot key={index} disabled />
        ))}
      </S.TimeColumn>
    );
  },
);
